function init() {
  const forms = document.querySelectorAll('.mcSignup');
  
  forms.forEach(formEl => {
    const formCl = formEl.classList;
    formEl.addEventListener('submit', e => {
      e.preventDefault();
    
      submitNewsletterForm(formEl);
    }); // addEventListener
    
    // If the user clicks a subscribe button on a closed form, open it up (show the fields)
    const subscribeButton = formEl.querySelector('.newsletter__subscribe');
    subscribeButton && subscribeButton.addEventListener('click', function(e) {
      
      if (formCl.contains('newsletter__form') && !formCl.contains('newsletter__form--open')) {
        e.preventDefault();
        formCl.add('newsletter__form--open');
      }
    });
    
    // The email input can be made visible when focused.  If there are any changes, ensure they remain visible by opening the form
    const emailInput = formEl.querySelector('input[name=EMAIL]');
    emailInput && emailInput.addEventListener('change', () => formCl.add('newsletter__form--open'));
  }); // forEach
}

function handleMcResponse(response, formEl) {
  const result = response && response.result;
  let errorMsg = null;
  
  if (!result) {
    errorMsg = "An error occurred submitting your request.  Please try again later.";
  }
  else if (result !== 'success') {
    errorMsg = (response.msg || "An unknown error occurred.  Please try again later.");
  }
  
  formEl.classList.add('newsletter__form--response');
    
  if (errorMsg !== null) {
    const errorEl = formEl.querySelector('.newsletter__error');
    errorEl.innerText = errorMsg;
    formEl.classList.add('newsletter__form--error');
    console.error("Error response from MailChimp", response);
  }
  else {
    formEl.classList.add('newsletter__form--success');
  }
}

function submitNewsletterForm(formEl) {
  if (!formEl.checkValidity()) {
    formEl.reportValidity();
    return;
  }
  
  const formData = new FormData(formEl);
  const functionName = "McNewsletterSignup_" + Date.now();
  
  window[functionName] = (response) => handleMcResponse(response, formEl);
  
  const paramStr = new URLSearchParams(formData).toString() + '&c=' + functionName;
  
  const baseUrl = formEl.getAttribute('action').replace('subscribe/post', 'subscribe/post-json');
  const action = `${ baseUrl }&${ paramStr }`;

  // Call MailChimp using json-p
  const script = document.createElement('script');
  script.src = action;
  document.body.append(script);
}


export default { init };